import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    get: {
        method: 'GET',
        url: `${BASE_PATH_API}/users/associationUsers`,
        params: {
            '$count': true
        }
    }
};

export function AssociationUsersApi(
    $httpParamSerializer
) {
    const service = createActions(actions);

    service.getAssociationUsersExportUrl = function getAssociationUsersExportUrl(params) {
        return `${BASE_PATH_API}/users/associationUsers/export?${$httpParamSerializer(params)}`;
    };

    return service;
}
AssociationUsersApi.$inject = [
    '$httpParamSerializer'
];
